import * as Types from '@trello/graphql/generated';

import { useQuickLoad } from '@trello/quickload';
import type { TrelloQueryHookOptions, TrelloLazyQueryHookOptions, TrelloSuspenseQueryHookOptions } from '@trello/quickload';
import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const WorkspaceJoinRequestMemberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WorkspaceJoinRequestMember"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"idEnterprise"}},{"kind":"Field","name":{"kind":"Name","value":"nonPublic"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"WorkspaceJoinRequestMember","document":WorkspaceJoinRequestMemberDocument}} as const;
export type WorkspaceJoinRequestMemberQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type WorkspaceJoinRequestMemberQuery = (
  { __typename: 'Query' }
  & { member?: Types.Maybe<(
    { __typename: 'Member' }
    & Pick<Types.Member, 'id' | 'avatarUrl' | 'fullName' | 'idEnterprise' | 'username'>
    & { nonPublic?: Types.Maybe<(
      { __typename: 'Member_NonPublic' }
      & Pick<Types.Member_NonPublic, 'avatarUrl' | 'fullName'>
    )> }
  )> }
);

/**
 * __useWorkspaceJoinRequestMemberQuery__
 *
 * To run a query within a React component, call `useWorkspaceJoinRequestMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceJoinRequestMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceJoinRequestMemberQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWorkspaceJoinRequestMemberQuery(
  baseOptions: TrelloQueryHookOptions<
    WorkspaceJoinRequestMemberQuery,
    WorkspaceJoinRequestMemberQueryVariables
  > &
    (
      | { variables: WorkspaceJoinRequestMemberQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const isQuickLoading = useQuickLoad({
    waitOn: baseOptions?.waitOn || ['None'],
    document: WorkspaceJoinRequestMemberDocument,
    skip: baseOptions?.skip,
  });
  const options = {
    ...defaultOptions,
    ...baseOptions,
    skip: isQuickLoading || baseOptions?.skip,
  };
  const result = Apollo.useQuery<
    WorkspaceJoinRequestMemberQuery,
    WorkspaceJoinRequestMemberQueryVariables
  >(WorkspaceJoinRequestMemberDocument, options);
  // reconstruct result because modifying the useQuery result actually changes apollo behavior because of memoization
  const trelloResult = { ...result };
  if (isQuickLoading) {
    trelloResult.loading = true;
  }

  return trelloResult;
}
export function useWorkspaceJoinRequestMemberLazyQuery(
  baseOptions?: TrelloLazyQueryHookOptions<
    WorkspaceJoinRequestMemberQuery,
    WorkspaceJoinRequestMemberQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    WorkspaceJoinRequestMemberQuery,
    WorkspaceJoinRequestMemberQueryVariables
  >(WorkspaceJoinRequestMemberDocument, options);
}
export function useWorkspaceJoinRequestMemberSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | TrelloSuspenseQueryHookOptions<
        WorkspaceJoinRequestMemberQuery,
        WorkspaceJoinRequestMemberQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    WorkspaceJoinRequestMemberQuery,
    WorkspaceJoinRequestMemberQueryVariables
  >(WorkspaceJoinRequestMemberDocument, options);
}
export type WorkspaceJoinRequestMemberQueryHookResult = ReturnType<
  typeof useWorkspaceJoinRequestMemberQuery
>;
export type WorkspaceJoinRequestMemberLazyQueryHookResult = ReturnType<
  typeof useWorkspaceJoinRequestMemberLazyQuery
>;
export type WorkspaceJoinRequestMemberSuspenseQueryHookResult = ReturnType<
  typeof useWorkspaceJoinRequestMemberSuspenseQuery
>;
export type WorkspaceJoinRequestMemberQueryResult = Apollo.QueryResult<
  WorkspaceJoinRequestMemberQuery,
  WorkspaceJoinRequestMemberQueryVariables
>;
